module.exports = __webpack_public_path__ + "img/ad.1fd001f0.jpg";